export default function createMapPlaceholder() {
  const elem = document.createElement("div");
  elem.style.height = "600px";
  elem.style.width = "100%";
  elem.style.background = "#d7c7ff";
  return elem;
}
